<template>
  <div class="home">
    <HeaderComp />
    <HeroComp />
    <ComoComp />
    <IntegracaoComp />
    <RecursoComp />
    <PlanoComp />
    <FaqComp />
    <FooterComp />
</div>
</template>

<script>
import HeaderComp from '@/components/Header.vue'
import HeroComp from '@/components/Hero.vue'
import ComoComp from '@/components/ComoComp.vue'
import IntegracaoComp from '@/components/IntegracaoComp.vue'
import RecursoComp from '@/components/RecursoComp.vue'
import PlanoComp from '@/components/PlanoComp.vue'
import FaqComp from '@/components/FaqComp.vue'
import FooterComp from '@/components/Footer.vue'

export default {
  name: 'HomeView',
  components: {
    HeaderComp,
    HeroComp,
    ComoComp,
    IntegracaoComp,
    RecursoComp,
    PlanoComp,
    FaqComp,
    FooterComp
  }
}

</script>
